import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CONVERSATION_FILTERS } from "@/api/queries/conversations";
import { ConversationsLayout } from "@/features/conversations/conversations-layout";

export const Route = createFileRoute("/_authenticated/$store/conversations")({
  validateSearch: z.object({
    filter: z.enum(CONVERSATION_FILTERS).optional().catch(undefined),
    q: z.string().trim().min(1).max(100).optional().catch(undefined),
    /** Show lost and opted-out sellers, hidden by default. */
    closed: z.boolean().optional().catch(undefined),
  }),
  head: () => ({ meta: [{ title: "Conversations · Rogue AI" }] }),
  component: ConversationsLayout,
});
